/*! Element Plus v2.3.5 */

var ja = {
  name: "ja",
  el: {
    colorpicker: {
      confirm: "OK",
      clear: "\u30AF\u30EA\u30A2"
    },
    datepicker: {
      now: "\u73FE\u5728",
      today: "\u4ECA\u65E5",
      cancel: "\u30AD\u30E3\u30F3\u30BB\u30EB",
      clear: "\u30AF\u30EA\u30A2",
      confirm: "OK",
      selectDate: "\u65E5\u4ED8\u3092\u9078\u629E",
      selectTime: "\u6642\u9593\u3092\u9078\u629E",
      startDate: "\u958B\u59CB\u65E5",
      startTime: "\u958B\u59CB\u6642\u9593",
      endDate: "\u7D42\u4E86\u65E5",
      endTime: "\u7D42\u4E86\u6642\u9593",
      prevYear: "\u524D\u5E74",
      nextYear: "\u7FCC\u5E74",
      prevMonth: "\u524D\u6708",
      nextMonth: "\u7FCC\u6708",
      year: "\u5E74",
      month1: "1\u6708",
      month2: "2\u6708",
      month3: "3\u6708",
      month4: "4\u6708",
      month5: "5\u6708",
      month6: "6\u6708",
      month7: "7\u6708",
      month8: "8\u6708",
      month9: "9\u6708",
      month10: "10\u6708",
      month11: "11\u6708",
      month12: "12\u6708",
      weeks: {
        sun: "\u65E5",
        mon: "\u6708",
        tue: "\u706B",
        wed: "\u6C34",
        thu: "\u6728",
        fri: "\u91D1",
        sat: "\u571F"
      },
      months: {
        jan: "1\u6708",
        feb: "2\u6708",
        mar: "3\u6708",
        apr: "4\u6708",
        may: "5\u6708",
        jun: "6\u6708",
        jul: "7\u6708",
        aug: "8\u6708",
        sep: "9\u6708",
        oct: "10\u6708",
        nov: "11\u6708",
        dec: "12\u6708"
      }
    },
    select: {
      loading: "\u30ED\u30FC\u30C9\u4E2D",
      noMatch: "\u30C7\u30FC\u30BF\u306A\u3057",
      noData: "\u30C7\u30FC\u30BF\u306A\u3057",
      placeholder: "\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044"
    },
    cascader: {
      noMatch: "\u30C7\u30FC\u30BF\u306A\u3057",
      loading: "\u30ED\u30FC\u30C9\u4E2D",
      placeholder: "\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
      noData: "\u30C7\u30FC\u30BF\u306A\u3057"
    },
    pagination: {
      goto: "",
      pagesize: "\u4EF6/\u30DA\u30FC\u30B8",
      total: "\u7DCF\u8A08 {total} \u4EF6",
      pageClassifier: "\u30DA\u30FC\u30B8\u76EE\u3078",
      page: "Page",
      prev: "Go to previous page",
      next: "Go to next page",
      currentPage: "page {pager}",
      prevPages: "Previous {pager} pages",
      nextPages: "Next {pager} pages"
    },
    messagebox: {
      title: "\u30E1\u30C3\u30BB\u30FC\u30B8",
      confirm: "OK",
      cancel: "\u30AD\u30E3\u30F3\u30BB\u30EB",
      error: "\u6B63\u3057\u304F\u306A\u3044\u5165\u529B"
    },
    upload: {
      deleteTip: "Del\u30AD\u30FC\u3092\u62BC\u3057\u3066\u524A\u9664\u3059\u308B",
      delete: "\u524A\u9664\u3059\u308B",
      preview: "\u30D7\u30EC\u30D3\u30E5\u30FC",
      continue: "\u7D9A\u884C\u3059\u308B"
    },
    table: {
      emptyText: "\u30C7\u30FC\u30BF\u306A\u3057",
      confirmFilter: "\u78BA\u8A8D",
      resetFilter: "\u521D\u671F\u5316",
      clearFilter: "\u3059\u3079\u3066",
      sumText: "\u5408\u8A08"
    },
    tree: {
      emptyText: "\u30C7\u30FC\u30BF\u306A\u3057"
    },
    transfer: {
      noMatch: "\u30C7\u30FC\u30BF\u306A\u3057",
      noData: "\u30C7\u30FC\u30BF\u306A\u3057",
      titles: ["\u30EA\u30B9\u30C8 1", "\u30EA\u30B9\u30C8 2"],
      filterPlaceholder: "\u30AD\u30FC\u30EF\u30FC\u30C9\u3092\u5165\u529B",
      noCheckedFormat: "\u7DCF\u8A08 {total} \u4EF6",
      hasCheckedFormat: "{checked}/{total} \u3092\u9078\u629E\u3057\u305F"
    },
    image: {
      error: "\u5931\u6557"
    },
    pageHeader: {
      title: "\u623B\u308B"
    },
    popconfirm: {
      confirmButtonText: "\u306F\u3044",
      cancelButtonText: "\u3044\u3044\u3048"
    }
  }
};

export { ja as default };
